import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';
import collectionsReducersMap from './collections/reducersMap';
import formsReducersMap from './forms/reducersMap';
import objectsReducersMap from './objects/reducersMap';

const combineMap = {
  collections: collectionsReducersMap,
  lists: listsReducersMap,
  forms: formsReducersMap,
  objects: objectsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('messengerModule', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/messenger/reducers/static/combineRegistry.js